import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './InternalCreateScreen';
import InternalCreate from './InternalCreateScreen';
import { StoreState } from 'src/store/reducers';
import { getProvidersSmall } from '../../../../../../store/actions/provider-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        inProgress: state.internals.inProgress,
        providers: state.providers.data,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getProviders: (params) => dispatch(getProvidersSmall(params)),
    };
}

const InternalCreateScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(InternalCreate);

export default InternalCreateScreen;
